// extracted by css-extract-rspack-plugin
export default {"root":"XzT992qtzcjcxYYa","indicator":"XY2VDJ_98boEhHOu","icon":"K5Eb2FCOZUXVRVzk","centered":"HPveDoxjjKcq0RNT","ellipsis":"nx7t1vbLbUQebpDB","ellipsis-pulse":"IMhdXvdDp0nCirmv"};